module.exports = __webpack_public_path__ + "img/logo.fcf96066.png";